export const APPLICATION_STATUS = {
    SUBMITTED: 'SUBMITTED',
    APPROVED: 'APPROVED', 
    CONTRACT_CONCLUSION: 'CONTRACT_CONCLUSION',
    COMPLETED: 'COMPLETED',
    REJECTED: 'REJECTED'
};

// i18n-ключи лейблов статусов. Идентификаторы статусов (значения логики) НЕ менять.
// В компонентах выводить t(APPLICATION_STATUS_DISPLAY[status]) или getStatusLabel(status, t).
export const APPLICATION_STATUS_DISPLAY = {
    SUBMITTED: 'dashboard.appStatus.SUBMITTED',
    APPROVED: 'dashboard.appStatus.APPROVED',
    CONTRACT_CONCLUSION: 'dashboard.appStatus.CONTRACT_CONCLUSION',
    COMPLETED: 'dashboard.appStatus.COMPLETED',
    REJECTED: 'dashboard.appStatus.REJECTED'
};

// Возвращает локализованный лейбл статуса. Если код неизвестен — возвращает сам код.
export const getStatusLabel = (status, t) =>
    APPLICATION_STATUS_DISPLAY[status] ? t(APPLICATION_STATUS_DISPLAY[status]) : status;